class LocationStore {

  constructor() {
    this.bindActions(this.alt.getActions('Location'));

    this.searchResults = [];
    this.userLocations = [];
    this.currentLocation = null;
    this.errors = {};
  }

  onSearchSuccess(results) {
    this.searchResults = results;
    delete this.errors['search'];
  }

  onSearchFail({ error }) {
    this.searchResults = [];
    this.errors['search'] = error;
  }

  onUpdateCurrentSuccess(currentLocation) {
    this.currentLocation = currentLocation;
    delete this.errors['updateCurrent'];
  }

  onUpdateCurrentFail({ error }) {
    this.errors['updateCurrent'] = error;
  }

  onReadUserLocationsSuccess(locations) {
    this.userLocations = locations;
    delete this.errors['readUserLocations'];
  }

  onUpdateUserLocationsSuccess(locations) {
    this.userLocations = locations;
    delete this.errors['readUserLocations'];
  }

}

export default LocationStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Location.js